import { Card, Col, Row } from "antd";
import type { Audit } from "../../../types/audits";
import spacing from "../../../components/ui/spacingConfig";
import StatusBadges from "../../../components/tables/StatusBadges";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  auditData: Audit | undefined;
  className?: string;
};

const CardDescriptionAudit: React.FC<Props> = ({ auditData, className }) => {
  return (
    <Card title="Description" bordered={false} className={className}>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Statut</p>
        </Col>
        <Col span={spacing.xs}>
          {auditData?.status ? (
            <StatusBadges value={auditData.status} type="audits" />
          ) : (
            "-"
          )}
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Titre</p>
        </Col>
        <Col span={spacing.xs}>
          <p>{auditData?.title}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Description</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-small-size">{auditData?.description || "-"}</p>
        </Col>
      </Row>
      <Row gutter={spacing.s}>
        <Col span={spacing.xs}>
          <p className="text-light-grey">PiÃ¨ces jointes</p>
        </Col>
        <Col span={spacing.xs}>
          <div className="attachments-container">
            {auditData?.attachedFiles?.map((file) => (
              <AttachmentPreview key={file.id} fileUrl={file.file} />
            ))}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDescriptionAudit;
